// extracted by mini-css-extract-plugin
export default {"column-row-selection":"columns_column-row-selection__9RzT6"};